import React from "react";
import { Helmet } from "react-helmet";
import Ctapage from "../../Components/internal-pages/Cta_Section";
import LeftContentRightImg from "../../Components/sub-pages/Left-content-right-image";
import { Container } from "react-bootstrap";
import NogapleftImg from "../../Components/sub-pages/NogapleftImg";
import StaticFaqs from "../../Components/Contact-us/FAQs";
import DynamicFaqs from "../../Components/home/Faqs";

const DiwaliGifts = () => {
    const CTAContent = [
        {
          pageName: "Corporate Diwali Gifts for Employees 2025",
          paragraphitalic: "Customized Hampers & Gift Ideas",
          paragraphText:
                "Celebrate this Diwali by appreciating your team with thoughtful corporate Diwali gifts for employees. From Diwali hampers under 1000, 2000 & 5000 to customized corporate gifts, eYantra brings you exclusive employee gifting solutions with pan-India delivery.",
          ContactFormName: "Diwali Gifts",
        },
      ];
    
      const SubpgesLeftContent = [
        {
          index: 0,
          sectionName: "Traditional Diyas & Puja Kits",
          parapgraphItalic: "Light Up Traditions, Brighten Every Celebration!",
          sectionparagraphText: (
            <>
              <p>
                Light up Diwali with traditional Diwali gifts for employees such as eco-friendly diyas, candles, and puja essentials. These spiritual and budget-friendly hampers are perfect as Diwali gifts under 1000 for large employee groups while keeping the festive spirit alive.
              </p>
            </>
          ),
          ImgSrc: "../assests/images/diwali-gifts/Traditional Diyas & Puja Kits.jpg",
          
        },
    
        /**Catagory Img */
        {
          index: 1,
          sectionName: "Gourmet Sweet Boxes",
          parapgraphItalic: "Indulge in the Sweet Side of Festivities!",
          sectionparagraphText: (
            <>
              <p>
                Sweeten the celebrations with Diwali gift hampers filled with premium mithai, dry fruits, chocolates, and healthy alternatives. A timeless choice for corporate Diwali gifting, these gourmet boxes are available in Diwali gifts under 2000 for teams and luxury hampers under 5000 for senior executives
              </p>
            </>
          ),
          ImgSrc: "../assests/images/diwali-gifts/Gourmet Sweet Boxes.jpg",
          categoryHeadingLeftSide: "Features that Delight",
          CategoriesLeftContent: [
            {
              CategoryImg: "../assests/images/diwali-gifts/Curated Selection.png",
              CategoryName: (
                <>
                  <p className="fs-14">
                    <b>Curated Selection</b> <br></br>
                  </p>
                </>
              ),
            },
            {
              CategoryImg: "../assests/images/diwali-gifts/Premium Packaging.png",
              CategoryName: (
                <>
                  <p className="fs-14">
                    <b>Premium Packaging</b> <br></br>
                  </p>
                </>
              ),
            },
            {
              CategoryImg: "../assests/images/diwali-gifts/Custom Branding.png",
              CategoryName: (
                <>
                  <p className="fs-14">
                    <b>Custom Branding</b> <br></br>
                  </p>
                </>
              ),
            },
          ],
        },
        {
          index: 2,
          sectionName: "Customized Corporate Diwali Hampers",
          parapgraphItalic: "",
          sectionparagraphText: (
            <>
              <p>
                Create memorable gifting experiences with personalized Diwali hampers. Add your company logo, include festive messages, and choose customized packaging that reflects your brand. These tailored hampers make your corporate Diwali gifts stand out while strengthening employee and client relationships.
              </p>
              <h2>Diwali Gifts by Budget</h2>
              <ul>
                <li>
                 <b> Diwali Gifts under 1000</b> → Eco-friendly gifts, festive stationery, personalized mugs, and small, sweet boxes. Perfect for bulk gifting.
                </li>
                <li>
                  <b>Diwali Gifts under 2000</b> → Balanced hampers with chocolates, dry fruits, wellness kits, and festive accessories.
                </li>
                <li>
                  <b>Diwali Gifts under 5000</b> → Premium gift sets, luxury hampers, and branded items for senior employees and key clients.
                </li>
              </ul>
              <p>
                Whatever your budget, eYantra ensures premium quality and festive appeal in every hamper.
              </p>
             
            </>
          ),
          ImgSrc: "../assests/images/diwali-gifts/Diwali Hamper.jpg",
          
        },
      ];
      const noGapContent = [
        {
          RightImgNogap: "../assests/images/diwali-gifts/Features that Illuminate.jpg",
          NogapHeading: "Features that Illuminate",
          Heading: [
            {
              ListHeading: "Why companies choose eYantra for corporate Diwali gift",
              ListParagraph:
                "",
            },
            {
              ListHeading: "Customized hampers with branding & festive packaging",
              ListParagraph:
                "",
            },
            {
              ListHeading: "Wide price range – Diwali gifts under 1000, 2000 & 5000.",
              ListParagraph:
                "",
            },
            {
              ListHeading: "Pan-India delivery for bulk orders",
              ListParagraph:
                "",
            },
            {
              ListHeading: "Unique & useful Diwali gift ideas for employees.",
              ListParagraph:
                "",
            },
          ],
        },
        {
          RightImgNogap: "../assests/images/diwali-gifts/Exclusive Home Décor Items.jpg",
          NogapHeading: "Exclusive Home Décor Items",
          paragraphItalic: "Transform Spaces, Celebrate in Style!",
          paragraphDetail: (
            <>
            <p>
                Bring style and elegance to employee gifting with exclusive home décor pieces such as festive lamps, designer trays, and decorative accessories. These customized Diwali gifts for employees are not only beautiful but also useful Diwali gifts that employees can cherish long after the festival.
            </p>
            </>
          ),
    
          NogapSubheading: "Features that Impress",
          Categories: [
            {
              ServiceImg: "../assests/images/diwali-gifts/Artisanal Designs.png",
              ServiceText: (
                <>
                  <p className="fs-14">
                    <b>Artisanal Designs</b>
                  </p>
                </>
              ),
            },
            {
              ServiceImg: "../assests/images/diwali-gifts/Wide Range of Options.png",
              ServiceText: (
                <>
                  <p className="fs-14">
                    <b>Wide Range of Options</b>
                  </p>
                </>
              ),
            },
            {
              ServiceImg: "../assests/images/diwali-gifts/Custom Personalization.png",
              ServiceText: (
                <>
                  <p className="fs-14">
                    <b>Custom Personalization</b>
                  </p>
                </>
              ),
            },
          ],
        },
    
        /**new index */
        {
          RightImgNogap: "../assests/images/sub-pages/IMG-5.png",
          NogapHeading: "Milestone Recognition ",
          paragraphItalic: "Make sure every gift reflects excellence.",
          paragraphDetail: (
            <>
              <p>Appreciate dedication and achievements.</p>
              <p>
                Show appreciation for the hard work and dedication that goes into
                every achievement.
              </p>
              <p>
                Milestones such as work anniversaries, project completions, and
                promotions deserve to be celebrated. At eYantra, we provide a range
                of premium milestone gifts that are as unique as the achievements.
              </p>
            </>
          ),
    
          NogapSubheading: "Our Milestone Gift Options Include:",
          Categories: [
            {
              ServiceImg: "../assests/images/sub-pages/logo-printing.png",
              ServiceText: (
                <>
                  <p className="fs-14">
                    <b>Personalized Awards</b>
                  </p>
                </>
              ),
            },
            {
              ServiceImg: "../assests/images/sub-pages/engraving.png",
              ServiceText: (
                <>
                  <p className="fs-14">
                    <b>Luxury Gift Hampers</b>
                  </p>
                </>
              ),
            },
            {
              ServiceImg: "../assests/images/sub-pages/color-matching.png",
              ServiceText: (
                <>
                  <p className="fs-14">
                    <b>Luxury Gift Hampers</b>
                  </p>
                </>
              ),
            },
          ],
        },
      ];

      const faqsData = [
        {
          question: "What are the best Diwali gifts for employees in 2025?",
          answer:
            "The best Diwali gifts include customized hampers, useful lifestyle products, dry fruits, chocolates, and wellness kits.",
        },
        {
          question: "Q2. What are budget-friendly Diwali gift ideas for employees?",
          answer:"Popular choices are Diwali gifts under 1000 or 2000 such as sweet boxes, eco-friendly stationery, festive mugs, and small hampers."
        },
        {
          question: "Why choose customized Diwali gifts for employees?",
          answer: "Customized Diwali gifts with branding, packaging, and messages create a lasting impression and reinforce company culture.",
        },
        {
          question: "Q4. How can I decide Diwali gifts within a budget?",
          answer:"Decide your price range (under 1000, 2000, 5000) and select hampers that balance utility with festive appeal."
        },
        {
          question:"Can eYantra deliver bulk Diwali gifts across India?",
          answer:"Yes, we provide pan-India delivery for corporate Diwali gifting, ensuring timely and hassle-free distribution."
        },
        {
          question:"Are Diwali gifts tax-deductible for companies in India?",
          answer:
            "Yes, in many cases they are considered a business expense. Please confirm with your finance team",
        },];
    
  return (
    <>
      <Helmet>
        <title>
          Corporate Diwali Gifts for Employees | Customized Hampers and Diwali Gifting Ideas
        </title>
        <meta name="description" content="Discover the best Diwali gift ideas for employees – from budget gifts under 1000 & 2000 to customized hampers. Perfect corporate Diwali gifting for 2025."/>
        <meta name="keywords" content="Diwali gifts for employees, Diwali gift ideas for employees, corporate Diwali gifts, best Diwali gift for employees, Diwali gift hampers, customized Diwali gifts, useful Diwali gifts for employees, Diwali gifts under 1000, Diwali gifts under 2000, Diwali gifts under 5000"/>
        </Helmet>
        <div className="p-0 m-2">
      <Ctapage data={CTAContent} />
      <Container>
        <LeftContentRightImg data={SubpgesLeftContent[0]} />
      </Container>
      <NogapleftImg data={noGapContent[0]} />
      <Container>
        <LeftContentRightImg data={SubpgesLeftContent[1]} />
      </Container>
      <NogapleftImg data={noGapContent[1]} />
      <Container>
        <LeftContentRightImg data={SubpgesLeftContent[2]} />
      </Container>
      <Container className="rounded-5 p-0 m-2 mx-auto ">
       
          <h2 className="text-center my-4">Why Choose eYantra for Corporate Diwali Gifting?</h2>
          <ul className="fs-5 col-12 col-md-6 mx-auto my-3 " >
            <li>
            Wide range of Diwali gift ideas for employees.
            </li>
            <li>
            Flexible budgets – gifts under 1000, 2000 & 5000.</li>
            <li>Customized hampers with branding & packaging.</li>
            <li>Pan-India delivery for bulk orders.</li>
            <li>Years of expertise in corporate Diwali gifting in India.</li>
          </ul>
        </Container>
      
      <Container>
        <h2 className="text-center my-5 fs-48">Frequently Asked Questions</h2>
        <DynamicFaqs faqsDynamicContent={faqsData}/>
      </Container>
      </div>

      <p className="text-center fs-32 w-75 d-block m-auto py-5">
        Let your Diwali gifts speak volumes about your appreciation and goodwill. 
      </p>
    </>
  );
};

export default DiwaliGifts;
